import { Helmet } from 'react-helmet-async';
import React from 'react';

import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import OrgInitiativeCategoriesSettingsFormContainer from '../../../../containers/organizations/Settings/OrgInitiativeCategoriesFormContainer.jsx';

const InitiativeCategoriesSettings = ({ slug }) => (
  <>
    <Helmet>
      <title>Change Strategy Settings | ChangeSync</title>
    </Helmet>
    <OrgInitiativeCategoriesSettingsFormContainer slug={slug} />
  </>
);

InitiativeCategoriesSettings.getInitialProps = ({ query }) => ({
  slug: query.slug,
});

export default requireAuth(withRouterParams(InitiativeCategoriesSettings));
